function getCookie(name) {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  const arr = document.cookie.match(reg);
  if (arr) return unescape(arr[2]);
  return '';
}

function setCookie(name, value, seconds) {
  const exp = new Date();
  exp.setTime(exp.getTime() + seconds * 1000);
  document.cookie = `${name}=${escape(value)};expires=${exp.toGMTString()};path=/`;
}

function deleteCookie(name, seconds) {
  const exp = new Date();
  exp.setTime(exp.getTime() + seconds * 1000);
  document.cookie = `${name}=;expires=${exp.toGMTString()};path=/`;
}

const devmode = {
  status: () => getCookie('devmode'),
  enter: mode => {
    setCookie('devmode', mode || '1', 3600 * 24);
    window.location.reload();
  },
  exit: () => {
    deleteCookie('devmode', 0);
    window.location.reload();
  },
  render() {
    // 插入标签
    const tid = '_devmode_tips_';
    let tips = document.getElementById(tid);
    if (!tips) {
      tips = document.createElement('div');
      tips.id = tid;
      document.body.appendChild(tips);
    }
    tips.innerHTML = `<div>
<span>devmode</span>
<a href="javascript:devmode.exit()">exit</a>
<div>`;

    // 插入样式
    const sid = '_devmode_style_';
    let style = document.getElementById(sid);
    if (!style) {
      style = document.createElement('style');
      style.id = sid;
      document.head.appendChild(style);
    }
    style.innerHTML = `
#_devmode_tips_ {
position: absolute;
top: 0;
left: 0;
font-size: 11px;
text-align: center;
color: #fe21ff;
}
#_devmode_tips_ a {
color: #fe21ff;
text-decoration: underline;
}
.el-menu-logo {
background: linear-gradient(90deg, #64d9d6, transparent);
}`;
  },
  init: () => {
    if (window.location.search.includes('devmode')) {
      window.history.replaceState(null, null, window.location.href.replace(/devmode(=1)?/, '').replace(/[?#]$/, ''));
      setTimeout(() => devmode.enter());
      return;
    }
    const status = devmode.status();
    if (status) devmode.render(status);
  },
};

devmode.init();

window.devmode = devmode;
module.exports = devmode;
